import { jsx as _jsx } from "react/jsx-runtime";
import { ModuleFE_Dialog, ModuleFE_Toaster, TS_Dialog, TS_PropRenderer, TS_Radio } from '@nu-art/thunderstorm-frontend/index';
import { PathwayTypes, PathwayTypeToLabel } from '@app/pathway-shared';
import './Dialog_DuplicatePathway.scss';
import { ModuleFE_Pathway } from '../../../_entity/pathway/index.js';
export class Dialog_DuplicatePathway extends TS_Dialog {
    static show = (props) => {
        const model = {
            content: () => _jsx(Dialog_DuplicatePathway, { ...props, dialogId: 'dialog__duplicate-pathway' }),
            closeOverlayOnClick: () => false,
        };
        ModuleFE_Dialog.show(model);
    };
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.pathway = nextProps.pathway;
        state.targetType = state.pathway.type;
        return state;
    }
    // ######################## Logic ########################
    duplicatePathway = async () => {
        try {
            const request = { pathwayId: this.state.pathway._id, targetType: this.state.targetType };
            const response = await ModuleFE_Pathway._v1.duplicatePathway(request).executeSync();
            this.props.onPathwayDuplicated(response.newPathway);
            this.closeDialog();
        }
        catch (err) {
            ModuleFE_Toaster.toastError('Failed to duplicate pathway!');
            this.logError('Pathway duplication failed', err);
        }
    };
    // ######################## Render ########################
    renderHeader = () => {
        return `Duplicate Pathway - ${this.state.pathway.label}`;
    };
    renderBody = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Target Type', children: _jsx(TS_Radio, { groupName: 'pathway-type', values: [...PathwayTypes], checked: this.state.targetType, onCheck: type => this.setState({ targetType: type }), labelRenderer: type => PathwayTypeToLabel[type] }) });
    };
    buttons = () => {
        return {
            left: [
                {
                    content: 'Cancel',
                    variant: 'secondary',
                    onClick: () => this.closeDialog(),
                }
            ],
            right: [
                {
                    content: 'Duplicate',
                    variant: 'primary',
                    onClick: this.duplicatePathway,
                }
            ]
        };
    };
}
//# sourceMappingURL=Dialog_DuplicatePathway.js.map